import cssModules from './quoted.module.css';
import { QuotedProps } from './types';

export const Quoted = ({ children }: QuotedProps) => {
  return <blockquote className={cssModules.blockquote}>{children}</blockquote>;
};
